import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const Biometric = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M5.268 5.336a8.75 8.75 0 0 1 15.27 5.923c-.01.867-.1 1.969-.312 3.224"
      stroke={"currentColor"}
      fill="transparent"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M4.888 15.404c.889-1.915 1.146-3.73 1.152-4.289a5.752 5.752 0 0 1 4.343-5.52m2.813 0a5.76 5.76 0 0 1 3.643 2.824c.24.421.716 1.536.698 2.624m1.164 6.363c-.61-.964-1.176-2.84-1.389-3.682a24.842 24.842 0 0 1-2.465 7.484M6.096 19.194c2.314-3.097 2.915-6.799 2.927-8.049a2.75 2.75 0 1 1 5.5.055c-.02 1.988-.743 6.37-3.384 10.378"
      stroke={"currentColor"}
      fill="transparent"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M8.317 20.84a17.463 17.463 0 0 0 2.28-4.173c.436-1.02.707-2.13.787-2.558"
      stroke={"currentColor"}
      fill="transparent"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M11.803 12.197a.917.917 0 1 0 0-1.834.917.917 0 0 0 0 1.834Z"
      fill={"currentColor"}
    />
  </Icon>
);

export default Biometric;
